import React from 'react'
import PropTypes from 'prop-types'
import Row from 'component/utils/Row'
import Col from 'component/utils/Col'

const VideoRemoveContent = (props) => {
  const { translate, closeModal, onSubmit } = props

  return (
    <section>
      <Row>
        <Col xs={12}>
          <legend className='margin-top margin-bottom-double'>
            {translate('mobile-update.remove')}
          </legend>
        </Col>
      </Row>

      <Row>
        <Col xs={12} className='margin-bottom-double'>
          <span>{translate('mobile-update.confirm-message-remove')}</span>
        </Col>
      </Row>

      <Row className='margin-top-double margin-bottom'>
        <Col xs={6} md={6}>
          <button
            role='button'
            onClick={closeModal}
            className='button-hollow button-hollow-danger button-full align-center'
          >
            {translate('cancel_button_label')}
          </button>
        </Col>

        <Col xs={6} md={6}>
          <button
            type='button'
            onClick={onSubmit}
            className='button button-primary button-full'
          >
            {translate('confirm_button_label')}
          </button>
        </Col>
      </Row>
    </section>
  )
}

VideoRemoveContent.propTypes = {
  translate: PropTypes.func.isRequired,
  closeModal: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
}

export default VideoRemoveContent
